import React, { useState } from 'react';
import { HouseLine, User, Sparkle, Archive, ArrowUUpLeft, CaretDown, CaretUp } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';
import type { SupplyArchiveItem } from '../../lib/utils';
interface RentalClosureCardProps {
  item: SupplyArchiveItem;
}
export function RentalClosureCard({
  item
}: RentalClosureCardProps) {
  const [expanded, setExpanded] = useState(false);
  if (item.kind === 'retracted') {
    const {
      offer,
      retractedAt
    } = item;
    const date = new Date(retractedAt).toLocaleDateString('ro-RO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    return <div className="rounded-2xl bg-dark-2 border border-dark-4 p-5" data-id="element-825">
        <div className="flex items-start justify-between gap-4" data-id="element-826">
          <div className="flex items-center gap-3" data-id="element-827">
            <div className="w-10 h-10 rounded-full bg-dark-3 flex items-center justify-center shrink-0" data-id="element-828">
              <ArrowUUpLeft size={18} weight="regular" className="text-light-3" data-id="element-829" />
            </div>
            <div data-id="element-830">
              <p className="font-semibold text-light-1" data-id="element-831">
                Ofertă retrasă — {offer.toName}
              </p>
              <p className="text-xs text-light-4" data-id="element-832">{date}</p>
            </div>
          </div>
          <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-dark-3 border border-dark-4 text-[10px] font-medium text-light-3" data-id="element-833">
            Retrasă
          </span>
        </div>
        <div className="mt-4 bg-dark-3 rounded-xl p-3 border border-dark-4" data-id="element-834">
          <p className="text-sm text-light-2 italic line-clamp-2" data-id="element-835">
            "{offer.message}"
          </p>
        </div>
      </div>;
  }
  // Closure kind
  const {
    property,
    succesOffer,
    siblingOffers,
    closedAt
  } = item;
  const date = new Date(closedAt).toLocaleDateString('ro-RO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const propTitle = property.title || (property as any).name || 'Proprietate';
  return <div className="rounded-2xl bg-dark-2 border border-dark-4 overflow-hidden" data-id="element-836">
      {/* Header */}
      <div className="p-5 border-b border-dark-4 bg-dark-3/30" data-id="element-837">
        <div className="flex items-start justify-between gap-4" data-id="element-838">
          <div className="flex items-center gap-3" data-id="element-839">
            <div className="w-10 h-10 rounded-lg bg-dark-3 flex items-center justify-center shrink-0" data-id="element-840">
              <HouseLine size={20} weight="regular" className="text-light-2" data-id="element-841" />
            </div>
            <div data-id="element-842">
              <p className="font-semibold text-light-1" data-id="element-843">{propTitle}</p>
              <p className="text-xs text-light-4" data-id="element-844">Închiriată pe {date}</p>
            </div>
          </div>
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-lime-5/10 border border-lime-5/20 text-[10px] font-medium text-lime-1" data-id="element-845">
            <Sparkle size={10} weight="fill" data-id="element-846" />
            Închiriată
          </span>
        </div>
      </div>

      {/* Body */}
      <div className="p-5 space-y-4" data-id="element-847">
        {/* Succes Offer */}
        {succesOffer ? <div className="rounded-xl border border-lime-4/30 bg-lime-5/5 p-4 flex items-start gap-3" data-id="element-848">
            {succesOffer.toAvatar ? <img src={succesOffer.toAvatar} alt={succesOffer.toName} className="w-10 h-10 rounded-full object-cover shrink-0" data-id="element-849" /> : <div className="w-10 h-10 rounded-full bg-dark-3 flex items-center justify-center shrink-0" data-id="element-850">
                <User size={18} weight="regular" className="text-light-3" data-id="element-851" />
              </div>}
            <div className="min-w-0 flex-1" data-id="element-852">
              <p className="text-sm font-medium text-light-1" data-id="element-853">
                {succesOffer.toName}
              </p>
              <p className="text-xs text-light-3 mt-0.5" data-id="element-854">
                A acceptat oferta ta și s-a mutat.
              </p>
            </div>
          </div> : <div className="rounded-xl border border-lime-4/30 bg-lime-5/5 p-4 flex items-start gap-3" data-id="element-855">
            <div className="w-10 h-10 rounded-full bg-dark-3 flex items-center justify-center shrink-0" data-id="element-856">
              <User size={18} weight="regular" className="text-light-3" data-id="element-857" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-858">
              <p className="text-sm font-medium text-light-1" data-id="element-859">
                {property.rentedTenantName || 'Chiriaș extern'}
              </p>
              <p className="text-xs text-light-3 mt-0.5" data-id="element-860">
                Închiriată în afara platformei sau fără ofertă directă.
              </p>
            </div>
          </div>}

        {/* Sibling Offers */}
        {siblingOffers.length > 0 && <div className="pt-2" data-id="element-861">
            <button type="button" onClick={() => setExpanded(!expanded)} className="flex items-center justify-between w-full text-left" data-id="element-862">
              <span className="text-xs font-medium text-light-3" data-id="element-863">
                {siblingOffers.length} oferte arhivate automat
              </span>
              {expanded ? <CaretUp size={14} className="text-light-4" data-id="element-864" /> : <CaretDown size={14} className="text-light-4" data-id="element-865" />}
            </button>

            {expanded && <ul className="mt-3 space-y-2" data-id="element-866">
                {siblingOffers.map(o => <li key={o.id} className="rounded-lg bg-dark-3 p-3 flex items-center gap-3" data-id="element-867">
                    <div className="w-8 h-8 rounded-full bg-dark-4 flex items-center justify-center shrink-0" data-id="element-868">
                      <Archive size={14} weight="regular" className="text-light-3" data-id="element-869" />
                    </div>
                    <div className="min-w-0 flex-1" data-id="element-870">
                      <p className="text-sm font-medium text-light-2 truncate" data-id="element-871">
                        {o.toName}
                      </p>
                      <p className="text-[10px] text-light-4 truncate" data-id="element-872">
                        Ofertă trimisă pe{' '}
                        {new Date(o.sentAt).toLocaleDateString('ro-RO')}
                      </p>
                    </div>
                  </li>)}
              </ul>}
          </div>}
      </div>
    </div>;
}